import { FolderAccountIcon } from './FolderAccountIcon';

/**
 * author: Google
 * id 0C56278E-06DE-4D32-BA08-C78F3EB572CC
 * name folder-account
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-account.svg
 * tags
 * - Account / User 
 * - Files / Folders 
 */
export const FolderUserIcon = FolderAccountIcon;
export default FolderUserIcon